module.exports = __webpack_public_path__ + "img/logo-sena.47d29d11.svg";